import React from 'react';
import { Route } from 'react-router-dom';
import DashboardRoutes from './Dashboard/routes';
const routes = () => [<DashboardRoutes key="DashboardRoutes" />];

const DashboardRoute = () => <Route component={routes} />;

export default DashboardRoute;



// WEBPACK FOOTER //
// ./src/modules/screens/dashboard/routes.js